import { nextTick, onMounted, ref, watch } from 'vue';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { mediaQuery } from '../../scripts/lib/mediaQuery.js';

const templateElement = document.getElementById('image-view-thumbnails-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    images: {
      type: Array,
      required: true,
    },
    activeThumbnail: {
      type: Number,
      required: false,
      default: null,
    },
  },

  setup(props) {
    const minimumSlidesForNavigation = ref(5);
    const swiper = ref(null);
    const swiperInstance = ref(null);

    onMounted(() => {
      initializeSwiperSlider();
    });

    function initializeSwiperSlider() {
      let animationSpeedInMS = 300;
      if (mediaQuery.prefersReducedMotion()) {
        /* https://github.com/nolimits4web/Swiper/issues/1702 */
        animationSpeedInMS = 1;
      }
      swiperInstance.value = new Swiper(swiper.value, {
        // NOSONAR
        modules: [Pagination],
        speed: animationSpeedInMS,
        enabled: props.images.length > 1,
        direction: 'vertical',
        slidesPerView: 1,
        slideToClickedSlide: false,
        spaceBetween: 6,
        loop: false,
        pagination: {
          el: '.ents-image-view__thumbnails--pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="${className}" data-index="${index}"></span>`;
          },
        },
        on: {
          click() {
            scrollToTargetImage(this.clickedIndex);
          },
        },
      });
    }

    function reinitSwiperSlider() {
      if (swiperInstance.value) {
        swiperInstance.value.destroy();
        initializeSwiperSlider();
      }
    }

    function onPaginationClick(e) {
      const bullet = e.target.closest('.swiper-pagination-bullet');
      if (bullet) {
        const index = parseInt(bullet.getAttribute('data-index'), 10);
        scrollToTargetImage(index);
      }
    }

    function scrollToTargetImage(index) {
      const scrollTarget = document.querySelector(`[data-ents-image-view-index="${index}"]`);
      if (scrollTarget) {
        const scrollTargetTop = scrollTarget.getBoundingClientRect().top + window.scrollY;
        window.scroll({
          behavior: 'smooth',
          left: 0,
          top: scrollTargetTop,
        });
      }
    }

    watch(
      () => props.images,
      () => {
        nextTick(() => {
          reinitSwiperSlider();
        });
      },
    );

    watch(
      () => props.activeThumbnail,
      () => {
        nextTick(() => {
          if (props.activeThumbnail !== null) {
            swiperInstance.value.slideTo(props.activeThumbnail);
          }
        });
      },
    );

    return {
      minimumSlidesForNavigation,
      swiper,
      swiperInstance,
      onPaginationClick,
    };
  },
};
